import { FC } from 'react';
import { Card } from '@/components';
import { Typography } from '@/primer/components';

/**
 * Maintenance Page
 *
 * Displays a full-screen maintenance message when the app is in maintenance mode.
 * This is shown for PROD environments to prevent users from accessing the app
 * during deployments or scheduled maintenance.
 */
export const Maintenance: FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-lg w-full">
        <Card>
          <div className="p-6 text-center">
            <img
              src="/assets/images/logo-black.svg"
              alt="Influenster"
              className="h-auto mx-auto mb-8 w-[200px]"
            />
            <div className="mb-6 text-[60px]">🔧</div>
            <Typography
              variant="header"
              size="h1"
              className="text-3xl font-bold text-gray-900 mb-4"
            >
              We'll Be Right Back
            </Typography>
            <Typography
              variant="body"
              size="medium"
              className="text-base text-gray-600 leading-relaxed"
            >
              We're currently performing scheduled maintenance to improve your experience. Please
              check back shortly. We apologize for any inconvenience.
            </Typography>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Maintenance;
